import {translateDisplayKeyWithFallback as translator} from 'gw-portals-displaykeys-translator-js';

export default (question) => {

    const choices = question.choices.map((choice) => {
        return {
            'code': choice.choiceCode,
            'name': translator(choice.displayKey)
        };
    });

    return {
        'availableValues': {
            value: choices
        }
    };
};